import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Header from "./cell/header"
import Content from "./cell/content"

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Schedule: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;

  return (
    <div className={cx(styles.main, className)}>
      <Header />
      <Content />
    </div>
  );
};

export default observer(Schedule);
// export default Main;
